import { throttle } from 'lodash';

export default [function() {
    return {
        throttle: (func, timeout, args) => {
            return throttle(func, timeout, args);
        }
    };
}];


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/throttle.service.js